import React from "react";
import PdfConsistencyAnalysis from "./PdfConsistencyAnalysis";
import PdfTendencyNumbers from "./PdfTendencyNumbers";
import { Row } from "react-bootstrap";
import Col from "react-bootstrap/Col";

const AnsweringTendencyDesign_1 = ({ item }) => {
  return (
    <Row
      style={{
        height: Number(item.height),
      }}
    >
      <Col>
        <Row
          className={"mb-3 mt-3"}
          style={{
            padding: "20px 0px",
            background: "rgb(247, 247, 244)",
            borderRadius: "20px",
          }}
        >
          <PdfConsistencyAnalysis score={item?.consistencyScore} />
          <PdfTendencyNumbers numbers={item?.inventoryLeanNumbers} />
        </Row>
      </Col>
    </Row>
  );
};
export default AnsweringTendencyDesign_1;
